import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import InputColor from "../../../views/dashboard/settings/branding/InputColor";
import Modal from "../../modal-new";

export const RemoveTemplateModal = ({
  athleteId,
  templateToRemove,
  organizationCoachId,
}) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const handleRemoveTemplate = (e) => {
    let body = {
      templateId: templateToRemove._id,
      athleteId,
    };

    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }

    e.preventDefault();
    submit("/actions/annual-planner/remove-phase-template", {
      method: "POST",
      body,
    });
  };

  const handleCancel = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "phase-templates",
        templateId: "",
        templateToRemove: "",
      },
    });
  };

  return (
    <Modal
      className="annual-planner-modal remove-phase-template-modal"
      title={t("removeTemplateModal.title")}
    >
      <div className="body">
        <form
          className="annual-planner-modal-form remove-phase-template-modal-form"
          //     onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          <span className="chip warning">
            {t("removeTemplateModal.confirmMessage")}
          </span>

          <div role="wrapper" className="template-name">
            <label>{t("removeTemplateModal.phaseGroupNameLabel")}</label>
            <span className="phase-template-name">
              {templateToRemove.templateName}
            </span>
          </div>
          <div className="phases-labels" role="wrapper">
            <label>{t("removeTemplateModal.phaseNameLabel")}</label>
            <label>{t("removeTemplateModal.colorLabel")}</label>
          </div>
          {templateToRemove.phases.map((phase, index) => (
            <div
              className="phase"
              role="wrapper"
              key={`add-temp-phase-${index}`}
            >
              <span className="phase-name">{phase.phaseName}</span>
              <InputColor
                onlyRead
                colorValueClassNames="phase-color-text"
                value={phase.phaseColor}
                customClassNames={"phase-color"}
              />
            </div>
          ))}
        </form>
      </div>
      <footer className="phase-template-footer">
        <button
          type="submit"
          onClick={handleRemoveTemplate}
          role="button"
          data-action="delete"
        >
          <img src="/img/new-icons/red-trash.svg" />
          {t("common:delete")}
        </button>
        <button
          type="button"
          role="button"
          data-action="cancel"
          onClick={handleCancel}
        >
          {t("common:cancel")}
        </button>
      </footer>
    </Modal>
  );
};
